import { api } from "./config"
import { useAuthStore } from "@/stores/authStore"


export const update = async (userId: string, data: any) => {
  const accessToken = useAuthStore.getState().auth.accessToken
    const result = await api.put(`users/${userId}`, 
        data, 
        {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        }
    ).then((response: any) => response.data.data)
    return result
}

export const getUser = async (userId: string) => {
  const accessToken = useAuthStore.getState().auth.accessToken
    const result = await api.get(`users/${userId}`, {
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        },
    }).then((response: any) => response.data.data)
    return result
}

